import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "status"]

  connect() {
    // Add any initialization if needed
  }

  toggle(event) {
    // The form will submit automatically via onchange
    // This is just for any additional UI feedback if needed
    const isChecked = event.target.checked
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = isChecked ? '已复盘' : '未复盘'
    }
  }
}